import { render, staticRenderFns } from "./responsive-image.vue?vue&type=template&id=063bf9ae"
import script from "./responsive-image.vue?vue&type=script&lang=js"
export * from "./responsive-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/binhdoan/Work/Dev-gits/Shopify-KL/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063bf9ae')) {
      api.createRecord('063bf9ae', component.options)
    } else {
      api.reload('063bf9ae', component.options)
    }
    module.hot.accept("./responsive-image.vue?vue&type=template&id=063bf9ae", function () {
      api.rerender('063bf9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/responsive-image.vue"
export default component.exports